import React, { useState } from "react";
import { Grid, TextField, Box, Typography, Alert } from "@mui/material";
import { useSelector } from "react-redux";
import { LoadingButton } from "@mui/lab";

export default function UserSignUpForm({ handleSubmit }) {
  const authData = useSelector((state) => state.auth);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    acceptTerms: true,
  });

  const handleInputChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };
  return (
    <Box
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        if (form.confirmPassword === form.password) {
          handleSubmit(form);
        } else {
          window.alert("passwords do not match");
        }
      }}
    >
      <Grid container item justifyContent="center" spacing={3} mb={2}>
        <Grid item xs={12} md={6}>
          <TextField
            required
            fullWidth
            label="First Name"
            name="firstName"
            value={form.firstName}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            required
            label="Last Name"
            name="lastName"
            value={form.lastName}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            required
            label="Email"
            name="email"
            value={form.email}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            required
            type="password"
            label="Password"
            name="password"
            value={form.password}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            required
            type="password"
            label="Confirm Password"
            name="confirmPassword"
            value={form.confirmPassword}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid
          item
          container
          direction="column"
          alignItems="flex-start"
          justifyContent="flex-start"
          xs={12}
          md={12}
        >
          <Grid item my={2}>
            <Typography variant="body1" textAlign="center">
              We research all partners to ensure impactful, high integrity work.
            </Typography>
          </Grid>
          <Grid item>
            <LoadingButton
              variant="contained"
              size="small"
              type="submit"
              loading={authData.isLoading}
            >
              Request Access
            </LoadingButton>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{ marignTop: "10px" }}
          alignItems="flex-start"
          justifyContent="flex-start"
        >
          {authData.error && (
            <Alert severity="error">{authData.error.description}</Alert>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
